import React from "react";
import { formatMadridDate } from '../utils/dateUtils';

const LegalLayout = ({ children, title }) => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">{title}</h1>
            <p className="text-gray-600">Investments Made Easy, S.L.</p>
            <p className="text-sm text-gray-500">Última actualización: {formatMadridDate(new Date())}</p>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export const TermsAndConditions = () => {
  return (
    <LegalLayout title="Términos y Condiciones">
      <div className="prose prose-lg max-w-none">
        <h2>1. INFORMACIÓN GENERAL</h2>
        <p>
          El presente documento establece los términos y condiciones generales de uso del sitio web <strong>Vivendius</strong>, 
          propiedad de <strong>Investments Made Easy, S.L.</strong> (en adelante, &quot;la Empresa&quot;).
        </p>

        <div className="bg-gray-50 p-4 rounded-lg my-6">
          <h3 className="text-lg font-semibold mb-2">Datos de la Empresa:</h3>
          <ul className="space-y-1">
            <li><strong>Razón social:</strong> Investments Made Easy, S.L.</li>
            <li><strong>CIF:</strong> B67108373</li>
            <li><strong>Dirección:</strong> Carrer de Méndez Núñez, 8, 08003 Barcelona</li>
            <li><strong>Actividad:</strong> Promoción inmobiliaria y compraventa de inmuebles por cuenta propia</li>
          </ul>
        </div>

        <h2>2. OBJETO Y ÁMBITO DE APLICACIÓN</h2>
        <p>
          La Empresa se dedica a la compra, reforma y venta de viviendas en Barcelona y alrededores. 
          Estas condiciones regulan el uso del sitio web y los servicios ofrecidos.
        </p>

        <h2>3. SERVICIOS OFRECIDOS</h2>
        <ul>
          <li>Promoción y venta de viviendas reformadas</li>
          <li>Información sobre proyectos inmobiliarios</li>
          <li>Gestión de contactos y consultas</li>
          <li>Intermediación a través de la agencia partner Propietaris.Cat</li>
        </ul>

        <h2>4. RESPONSABILIDADES DEL USUARIO</h2>
        <p>El usuario se compromete a:</p>
        <ul>
          <li>Proporcionar información veraz y actualizada</li>
          <li>Usar el sitio web de forma responsable</li>
          <li>No realizar actividades que puedan dañar el sitio web</li>
          <li>Respetar la propiedad intelectual de la Empresa</li>
        </ul>

        <h2>5. GARANTÍAS PROFESIONALES</h2>
        <p>
          La Empresa ofrece garantía profesional en todos los acabados de las viviendas reformadas, 
          asegurando la calidad de los materiales y la ejecución de las obras.
        </p>

        <h2>6. LIMITACIÓN DE RESPONSABILIDAD</h2>
        <p>
          La Empresa no se responsabiliza de los daños que puedan derivarse del uso inadecuado del sitio web 
          o de interrupciones en el servicio por causas ajenas a su control.
        </p>

        <h2>7. PROPIEDAD INTELECTUAL</h2>
        <p>
          Todos los contenidos del sitio web, incluyendo textos, imágenes, logos y diseños, son propiedad de 
          Investments Made Easy, S.L. y están protegidos por las leyes de propiedad intelectual.
        </p>

        <h2>8. MODIFICACIONES</h2>
        <p>
          La Empresa se reserva el derecho a modificar estos términos y condiciones en cualquier momento, 
          notificando los cambios a través del sitio web.
        </p>

        <h2>9. LEGISLACIÓN APLICABLE</h2>
        <p>
          Estos términos y condiciones se rigen por la legislación española. Para cualquier controversia, 
          los tribunales competentes serán los de Barcelona.
        </p>

        <h2>10. CONTACTO</h2>
        <p>
          Para cualquier consulta relacionada con estos términos y condiciones, puede contactar con nosotros 
          a través de los medios proporcionados en el sitio web.
        </p>
      </div>
    </LegalLayout>
  );
};

export const PrivacyPolicy = () => {
  return (
    <LegalLayout title="Política de Privacidad">
      <div className="prose prose-lg max-w-none">
        <h2>1. RESPONSABLE DEL TRATAMIENTO</h2>
        <div className="bg-gray-50 p-4 rounded-lg my-6">
          <ul className="space-y-1">
            <li><strong>Responsable:</strong> Investments Made Easy, S.L.</li>
            <li><strong>CIF:</strong> B67108373</li>
            <li><strong>Dirección:</strong> Carrer de Méndez Núñez, 8, 08003 Barcelona</li>
            <li><strong>Email:</strong> info@vivendius.com</li>
          </ul>
        </div>

        <h2>2. FINALIDAD DEL TRATAMIENTO</h2>
        <p>Los datos personales se recopilan para:</p>
        <ul>
          <li>Gestionar consultas y solicitudes de información</li>
          <li>Proporcionar información sobre viviendas disponibles</li>
          <li>Gestionar procesos de compra-venta</li>
          <li>Enviar comunicaciones comerciales (con consentimiento)</li>
          <li>Cumplir con obligaciones legales</li>
        </ul>

        <h2>3. BASE LEGAL</h2>
        <p>El tratamiento se basa en:</p>
        <ul>
          <li><strong>Consentimiento:</strong> Para comunicaciones comerciales</li>
          <li><strong>Ejecución contractual:</strong> Para la gestión de compra-venta</li>
          <li><strong>Interés legítimo:</strong> Para la gestión de consultas</li>
          <li><strong>Obligación legal:</strong> Para cumplir con la normativa aplicable</li>
        </ul>

        <h2>4. DATOS RECOPILADOS</h2>
        <p>Recopilamos los siguientes tipos de datos:</p>
        <ul>
          <li>Datos de identificación (nombre, apellidos)</li>
          <li>Datos de contacto (email, teléfono)</li>
          <li>Datos de navegación (cookies, IP)</li>
          <li>Datos proporcionados en formularios</li>
        </ul>

        <h2>5. DESTINATARIOS</h2>
        <p>Los datos pueden ser comunicados a:</p>
        <ul>
          <li>Propietaris.Cat (agencia partner)</li>
          <li>Proveedores de servicios tecnológicos</li>
          <li>Organismos públicos cuando sea legalmente requerido</li>
        </ul>

        <h2>6. CONSERVACIÓN</h2>
        <p>
          Los datos se conservarán durante el tiempo necesario para cumplir con la finalidad para la que fueron 
          recopilados y para cumplir con las obligaciones legales aplicables.
        </p>

        <h2>7. DERECHOS DEL INTERESADO</h2>
        <p>Tiene derecho a:</p>
        <ul>
          <li><strong>Acceso:</strong> Obtener información sobre sus datos</li>
          <li><strong>Rectificación:</strong> Corregir datos inexactos</li>
          <li><strong>Supresión:</strong> Eliminar sus datos</li>
          <li><strong>Limitación:</strong> Restringir el tratamiento</li>
          <li><strong>Portabilidad:</strong> Recibir sus datos en formato estructurado</li>
          <li><strong>Oposición:</strong> Oponerse al tratamiento</li>
        </ul>

        <h2>8. SEGURIDAD</h2>
        <p>
          Implementamos medidas técnicas y organizativas apropiadas para proteger sus datos personales 
          contra accesos no autorizados, alteración, divulgación o destrucción.
        </p>

        <h2>9. TRANSFERENCIAS INTERNACIONALES</h2>
        <p>
          En caso de transferencias internacionales, garantizamos que se realizan con las garantías 
          adecuadas según la normativa aplicable.
        </p>

        <h2>10. CONTACTO</h2>
        <p>
          Para ejercer sus derechos o realizar consultas sobre esta política de privacidad, 
          puede contactar con nosotros a través de info@vivendius.com.
        </p>
      </div>
    </LegalLayout>
  );
};

export const CookiePolicy = () => {
  return (
    <LegalLayout title="Política de Cookies">
      <div className="prose prose-lg max-w-none">
        <h2>1. ¿QUÉ SON LAS COOKIES?</h2>
        <p>
          Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita nuestro sitio web. 
          Permiten que el sitio web recuerde sus acciones y preferencias durante un período de tiempo.
        </p>

        <h2>2. TIPOS DE COOKIES QUE UTILIZAMOS</h2>
        
        <h3>2.1 Cookies Necesarias</h3>
        <div className="bg-green-50 p-4 rounded-lg my-4">
          <p><strong>Finalidad:</strong> Funcionamiento básico del sitio web y autenticación</p>
          <p><strong>Duración:</strong> Sesión y persistentes</p>
          <p><strong>Tipo:</strong> Propia</p>
          <p><strong>Obligatorias:</strong> Sí, no se pueden desactivar</p>
        </div>

        <h3>2.2 Cookies de Análisis</h3>
        <div className="bg-blue-50 p-4 rounded-lg my-4">
          <p><strong>Finalidad:</strong> Análisis del comportamiento de los usuarios y mejora de la experiencia</p>
          <p><strong>Duración:</strong> 24 meses</p>
          <p><strong>Tipo:</strong> Terceros (Google Analytics)</p>
          <p><strong>Obligatorias:</strong> No, requiere consentimiento</p>
        </div>

        <h3>2.3 Cookies de Marketing</h3>
        <div className="bg-yellow-50 p-4 rounded-lg my-4">
          <p><strong>Finalidad:</strong> Publicidad personalizada y seguimiento de campañas</p>
          <p><strong>Duración:</strong> 12 meses</p>
          <p><strong>Tipo:</strong> Terceros (Facebook Pixel, Google Ads)</p>
          <p><strong>Obligatorias:</strong> No, requiere consentimiento</p>
        </div>

        <h3>2.4 Cookies Funcionales</h3>
        <div className="bg-purple-50 p-4 rounded-lg my-4">
          <p><strong>Finalidad:</strong> Funcionalidades mejoradas como recordar preferencias</p>
          <p><strong>Duración:</strong> 6 meses</p>
          <p><strong>Tipo:</strong> Propia</p>
          <p><strong>Obligatorias:</strong> No, requiere consentimiento</p>
        </div>

        <h2>3. COOKIES UTILIZADAS</h2>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2">Nombre</th>
                <th className="border border-gray-300 px-4 py-2">Finalidad</th>
                <th className="border border-gray-300 px-4 py-2">Duración</th>
                <th className="border border-gray-300 px-4 py-2">Tipo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-2">vivendius_cookie_consent</td>
                <td className="border border-gray-300 px-4 py-2">Almacena preferencias de cookies</td>
                <td className="border border-gray-300 px-4 py-2">12 meses</td>
                <td className="border border-gray-300 px-4 py-2">Necesaria</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">auth_token</td>
                <td className="border border-gray-300 px-4 py-2">Autenticación de usuarios</td>
                <td className="border border-gray-300 px-4 py-2">Sesión</td>
                <td className="border border-gray-300 px-4 py-2">Necesaria</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">_ga</td>
                <td className="border border-gray-300 px-4 py-2">Google Analytics - Identificador único</td>
                <td className="border border-gray-300 px-4 py-2">24 meses</td>
                <td className="border border-gray-300 px-4 py-2">Análisis</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">_gat</td>
                <td className="border border-gray-300 px-4 py-2">Google Analytics - Limitación de velocidad</td>
                <td className="border border-gray-300 px-4 py-2">1 minuto</td>
                <td className="border border-gray-300 px-4 py-2">Análisis</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">_gid</td>
                <td className="border border-gray-300 px-4 py-2">Google Analytics - Identificador de sesión</td>
                <td className="border border-gray-300 px-4 py-2">24 horas</td>
                <td className="border border-gray-300 px-4 py-2">Análisis</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">_fbp</td>
                <td className="border border-gray-300 px-4 py-2">Facebook Pixel - Seguimiento de conversiones</td>
                <td className="border border-gray-300 px-4 py-2">90 días</td>
                <td className="border border-gray-300 px-4 py-2">Marketing</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2>4. GESTIÓN DE COOKIES</h2>
        <p>
          Puede gestionar sus preferencias de cookies a través del banner que aparece en su primera visita 
          o accediendo a la configuración de su navegador.
        </p>

        <h3>4.1 Configuración del Navegador</h3>
        <p>La mayoría de navegadores permiten:</p>
        <ul>
          <li>Ver qué cookies están instaladas</li>
          <li>Bloquear cookies de terceros</li>
          <li>Borrar cookies al cerrar el navegador</li>
          <li>Eliminar cookies específicas</li>
        </ul>

        <h3>4.2 Enlaces de Configuración</h3>
        <ul>
          <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:underline">Chrome</a></li>
          <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:underline">Firefox</a></li>
          <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:underline">Safari</a></li>
          <li><a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:underline">Edge</a></li>
        </ul>

        <h2>5. CONSENTIMIENTO</h2>
        <p>
          Al utilizar nuestro sitio web, acepta el uso de cookies necesarias. Para cookies de análisis, 
          marketing y funcionales, requerimos su consentimiento expreso.
        </p>

        <h2>6. RETIRADA DEL CONSENTIMIENTO</h2>
        <p>
          Puede retirar su consentimiento en cualquier momento eliminando las cookies de su navegador 
          o contactándonos en info@vivendius.com.
        </p>

        <h2>7. CAMBIOS EN LA POLÍTICA</h2>
        <p>
          Podemos actualizar esta política de cookies. Le notificaremos cualquier cambio significativo 
          a través de nuestro sitio web.
        </p>

        <h2>8. CONTACTO</h2>
        <p>
          Para consultas sobre esta política de cookies, contacte con nosotros en info@vivendius.com.
        </p>
      </div>
    </LegalLayout>
  );
};